import React, {createContext, useState} from 'react';

import ErrorModal from '../components/modules/ErrorModal';
import OfflineNotice from '../components/modules/OfflineNotice';

import {NERWORK_ERROR, TOKEN_ERROR_1, TOKEN_ERROR_2} from '../utils/ApiHelper';

export const errorStatusContext = createContext();
const {Provider} = errorStatusContext;

const ErrorStatusContext = props => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState(false);

  const onPressClose = () => {
    setVisible(false);
  };

  const showError = errorMessage => {
    setMessage(errorMessage);
    setTimeout(() => {
      setVisible(true);
    }, 800);
  };

  return (
    <>
      <Provider
        value={{
          visible,
          message,
          showError,
        }}>
        {props.children}
      </Provider>
      {message != NERWORK_ERROR &&
        message != TOKEN_ERROR_1 &&
        message != TOKEN_ERROR_2 && (
          <ErrorModal
            visible={visible}
            message={message}
            onClose={onPressClose}
          />
        )}
      {message === NERWORK_ERROR && (
        <OfflineNotice visible={visible} onClose={onPressClose} />
      )}
    </>
  );
};

export default ErrorStatusContext;
